import React, { useEffect, useState } from "react";
import styles from "../components/style/configstyle.module.css";
import { ChevronLeftOutlined, ChevronRightOutlined, Create } from "@mui/icons-material";
import { getFetch, postFetch } from "../../../../../../fetch/fetch";
import { Backdrop, Box, CircularProgress, LinearProgress, Modal, ToggleButton, ToggleButtonGroup } from "@mui/material";
import AddWorkModal2 from "./addworkmodal2";
import { dateToDateString } from "../../../etc/etcfunctions";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { englishLocationToKorean, koreanLocationToEnglish } from "../../../../../../data/locationFuntion";
import { Button, Input } from "@mui/joy";
import WeekPayModal from "./weekpaymodal";
import IncentiveModal from "./incentivemodal";
import OtherLocationIncentiveModal from "./otherLocationIncentiveModal";
import MemoModal from "./memomodal";
import DefaultWorkSettingModal from "./defaultworksettingmodal";
import RegisterWorkManually from "./registerworkmanually";
import AddAccessModal from "./addaccessmodal";
import EmploymentInsuranceModal from "./employmentinsurancemodal";
import HolidayPayModal from "./holidaypaymodal";
import { calculateSimplifiedIncomeTax } from "./data/simplifiedincometax";
import totalLocationData from "../../../../../../data/locationdata";

// 대치점 / 대치3층 / 대치6층은 동일 지점 그룹으로 처리
const DAECHI_GROUP_ENG = ["daechi", "daechi2", "daechi3"];

const isSameLocationGroup = (itemLocationEng: string, userLocationKorean: string): boolean => {
    const homeEng = koreanLocationToEnglish(userLocationKorean);
    if (!homeEng) return false;
    if (DAECHI_GROUP_ENG.includes(itemLocationEng) && DAECHI_GROUP_ENG.includes(homeEng)) return true;
    return itemLocationEng === homeEng;
};

// 조퇴 차감 적용 시작일 (2026년 7월 10일 근무분부터)
const EARLY_LEAVE_DEDUCTION_START = new Date(2026, 6, 10);

const calculateWeekPayForData = (
    filteredData: any[],
    selectedWeekPayDays: number[],
    date: Date
): { weekPayDataArray: any[]; totalWeekPay: number } => {
    if (selectedWeekPayDays.length === 0) {
        return { weekPayDataArray: [], totalWeekPay: 0 };
    }

    const weekPayDataArray: any[] = [];
    const newDate = new Date(date.getFullYear(), date.getMonth(), 1);

    while (newDate.getMonth() === date.getMonth()) {
        const newDateDay = newDate.getDay();

        if (newDateDay === 0) {
            const weekPayData = {
                sundayDate: new Date(newDate),
                mondayDate: new Date(newDate).setDate(newDate.getDate() - 6),
                isWeekPayDay: false,
                minutes: 0,
                wage: 0,
            };

            var isWeekPayDay = true;

            const measureDate = new Date(newDate);
            measureDate.setDate(measureDate.getDate() - 6);

            const weekWageData: any[] = [];

            for (let i = 0; i < 7; i++) {
                const measureDateYear = measureDate.getFullYear();
                const measureDateMonth = measureDate.getMonth();
                const measureDateDate = measureDate.getDate();

                filteredData.forEach((item: any) => {
                    const itemDate = new Date(item.targetDate);
                    const itemYear = itemDate.getFullYear();
                    const itemMonth = itemDate.getMonth();
                    const itemDay = itemDate.getDate();

                    if (!item.isDefault && item.status !== 1 && !item.isManually) {
                        return;
                    }

                    if (item.isManually && !item.isDefault && !item.isRequested) {
                        return;
                    }

                    if (itemYear === measureDateYear && itemMonth === measureDateMonth && itemDay === measureDateDate) {
                        weekWageData.push(item);
                    }
                });
                measureDate.setDate(measureDate.getDate() + 1);
            }

            var isTotalExist = true;

            selectedWeekPayDays.forEach((day: number, index: number) => {
                if (!day) {
                    return;
                }
                const found = weekWageData.find((item: any) => {
                    const itemDate = new Date(item.targetDate);
                    return itemDate.getDay() === index;
                });
                if (!found) {
                    isTotalExist = false;
                }
            });

            if (!isTotalExist) {
                weekPayDataArray.push(weekPayData);
                newDate.setDate(newDate.getDate() + 1);
                continue;
            }

            var totalMinutes = 0;
            var totalWage = 0;

            weekWageData.forEach((item: any) => {
                totalMinutes += item.realMinutes;
                const hourlyWage = item.hourlyWage;
                const minuteWage = Math.ceil((hourlyWage / 60) * 10) / 10;
                const itemWage = minuteWage * item.realMinutes;
                totalWage += itemWage;
            });

            const totalWeekPayWage = Math.ceil((totalWage / 40) * 8);
            const isUpTo15Hours = totalMinutes >= 15 * 60;

            if (!isUpTo15Hours) {
                weekPayData.minutes = totalMinutes;
                weekPayDataArray.push(weekPayData);
                newDate.setDate(newDate.getDate() + 1);
                continue;
            }

            weekPayData.isWeekPayDay = true;
            weekPayData.minutes = totalMinutes;
            weekPayData.wage = totalWeekPayWage;
            weekPayDataArray.push(weekPayData);
        }

        newDate.setDate(newDate.getDate() + 1);
    }

    var totalWeekPay = 0;
    weekPayDataArray.forEach((weekPayItem: any) => {
        if (weekPayItem.isWeekPayDay) {
            totalWeekPay += weekPayItem.wage;
        }
    });

    return { weekPayDataArray, totalWeekPay };
};

const incomeTaxModalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: "16px",
    boxShadow: 24,
    p: 3,
    paddingLeft: 5,
    paddingRight: 5
};

const ShopSalaryRegister2: React.FC<any> = (props) => {

    const [activeTab, setActiveTab] = useState<"home" | "other">("home");

    const [date, setDate] = useState(new Date());

    const [calendarStart, setCalendarStart] = useState<Date>();
    const [calendarEnd, setCalendarEnd] = useState<Date>();

    const [loading, setLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalCalendarType, setModalCalendarType] = useState<"home" | "other">("home");
    const [modalOpen2, setModalOpen2] = useState(false);
    const [modalOpen3, setModalOpen3] = useState(false);
    const [modalOpen4, setModalOpen4] = useState(false);
    const [modalOpen5, setModalOpen5] = useState(false);
    const [modalOpen6, setModalOpen6] = useState(false);
    const [modalOpen7, setModalOpen7] = useState(false);

    const [data, setData] = useState<any>(null);
    const [userData, setUserData] = useState<any>(null);
    const [homeUserData, setHomeUserData] = useState<any[] | null>(null);
    const [otherUserData, setOtherUserData] = useState<any[] | null>(null);
    const [userAccessData, setUserAccessData] = useState<any>(null);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);

    const [selectedWorkId, setSelectedWorkId] = useState<number | null>(null);

    const [update, setUpdate] = useState(0);
    const [accessUpdate, setAccessUpdate] = useState(0);
    const [incentiveUpdate, setIncentiveUpdate] = useState(0);

    const open5 = Boolean(anchorEl);
    const open6 = Boolean(anchorEl2);

    const [centerLoading, setCentorLoading] = useState(false);

    const [selectedWeekPayDays, setSelectedWeekPayDays] = useState<number[]>([]);

    const [incentiveData, setIncentiveData] = useState<any[]>([]);
    const [otherLocationIncentiveData, setOtherLocationIncentiveData] = useState<any[]>([]);
    const [otherLocationIncentiveTotals, setOtherLocationIncentiveTotals] = useState<{ [loc: string]: number }>({});
    const [otherIncentiveModalOpen, setOtherIncentiveModalOpen] = useState(false);
    const [otherIncentiveUpdate, setOtherIncentiveUpdate] = useState(0);

    const [totalHoursWage, setTotalHoursWage] = useState(0);
    const [totalWeekPay, setTotalWeekPay] = useState(0);
    const [totalIncentive, setTotalIncentive] = useState(0);

    const [totalSalary, setTotalSalary] = useState(0);

    const [homeWeekPayDataArray, setHomeWeekPayDataArray] = useState<any[]>([]);
    const [otherWeekPayDataArrays, setOtherWeekPayDataArrays] = useState<{ [loc: string]: any[] }>({});
    const [otherLocationWages, setOtherLocationWages] = useState<{ [loc: string]: number }>({});
    const [otherLocationExtras, setOtherLocationExtras] = useState<{ [loc: string]: { extraAmount: number; memo: string } }>({});

    const [extraMemoModalOpen, setExtraMemoModalOpen] = useState(false);
    const [extraMemoEditLocation, setExtraMemoEditLocation] = useState("");
    const [extraMemoEditType, setExtraMemoEditType] = useState<"extra" | "memo">("extra");
    const [extraMemoInputValue, setExtraMemoInputValue] = useState("");
    const [extraMemoSaveLoading, setExtraMemoSaveLoading] = useState(false);

    const [isDefault, setIsDefault] = useState(true);
    const [isManually, setIsManually] = useState(false);

    const [tax, setTax] = useState(0);
    const [afterTax, setAfterTax] = useState(0);
    const [totalNightPay, setTotalNightPay] = useState(0);
    const [employmentInsurance, setEmploymentInsurance] = useState(false);
    const [modalOpen8, setModalOpen8] = useState(false);
    const [incomeTax, setIncomeTax] = useState(0);
    const [holidayPayApplied, setHolidayPayApplied] = useState(false);
    const [modalOpen9, setModalOpen9] = useState(false);
    const [holidays, setHolidays] = useState<any[]>([]);
    const [totalHolidayPay, setTotalHolidayPay] = useState(0);
    const [mockExams, setMockExams] = useState<any[]>([]);
    const [totalMockExamIncentive, setTotalMockExamIncentive] = useState(0);
    const [otherLocationMockExamIncentives, setOtherLocationMockExamIncentives] = useState<{ [loc: string]: number }>({});
    const [travelAllowances, setTravelAllowances] = useState<any[]>([]);
    const [otherLocationTravelAllowances, setOtherLocationTravelAllowances] = useState<{ [loc: string]: number }>({});

    useEffect(() => {
        setUserAccessData(null);
        setUserData(null);
        setHomeUserData(null);
        setOtherUserData(null);
        setHomeWeekPayDataArray([]);
        setOtherWeekPayDataArrays({});
        setOtherLocationWages({});
        setOtherLocationExtras({});
        setTotalHoursWage(0);
        setTotalWeekPay(0);
        setTotalNightPay(0);
        setTotalHolidayPay(0);
        setTotalMockExamIncentive(0);
        setOtherLocationMockExamIncentives({});
        setOtherLocationTravelAllowances({});
        setIncomeTax(0);
    }, [props.user?.id, date.getFullYear(), date.getMonth()]);

    useEffect(() => {

        setTotalSalary(totalHoursWage + totalWeekPay + totalIncentive + totalNightPay + totalHolidayPay + totalMockExamIncentive);

        const totalSalaryCalc = totalHoursWage + totalWeekPay + totalIncentive + totalNightPay + totalHolidayPay + totalMockExamIncentive;

        const taxRate = employmentInsurance ? 0.009 : 0.033;
        const tax = Math.floor(totalSalaryCalc * taxRate);

        // 근로소득세: 고용보험 적용자만, 간이세액표(공제대상가족수 1인) 자동 계산 — 총 합계를 월급여액으로 사용
        const incomeTaxCalc = employmentInsurance ? calculateSimplifiedIncomeTax(totalSalaryCalc) : 0;
        const afterTax = totalSalaryCalc - tax - incomeTaxCalc;

        setIncomeTax(incomeTaxCalc);
        setTax(tax);
        setAfterTax(afterTax);

    }, [totalHoursWage, totalWeekPay, totalIncentive, totalNightPay, totalHolidayPay, totalMockExamIncentive, employmentInsurance]);


    useEffect(() => {

        getData();

    }, []);

    useEffect(() => {

        console.log(props.user);
        console.log("go");

        if (!calendarStart || !calendarEnd) {
            return;
        }

        if (!userAccessData) {
            return;
        }

        if (props.user) {
            getUserData();
        }

    }, [props.user, calendarStart, calendarEnd, update, userAccessData, selectedWeekPayDays, holidays, holidayPayApplied, mockExams, data, travelAllowances]);

    useEffect(() => {

        if (!props.user) {
            return;
        }

        if (!calendarStart || !calendarEnd) {
            return;
        }

        getUserAccessData();

    }, [props.user, calendarStart, calendarEnd, accessUpdate]);

    useEffect(() => {

        if (!props.user) {
            return;
        }

        getWeekPayDays();

    }, [props.user]);

    useEffect(() => {

        if (!props.user) {
            return;
        }

        getEmploymentInsurance();

    }, [props.user]);

    // 공휴일 수당 적용 여부 — 유저별 설정이므로 월 변경 시 리셋 금지, user 변경 시만 re-fetch (고용보험과 동일)
    useEffect(() => {

        if (!props.user) {
            return;
        }

        getHolidayPay();

    }, [props.user]);

    // 공휴일·모의고사 날·출장비 목록 — 전 지점 공통, 마운트 시 1회
    useEffect(() => {

        getHolidays();
        getMockExams();
        getTravelAllowances();

    }, []);

    useEffect(() => {

        if (!props.user || !date) {
            return;
        }

        getOtherLocationExtras();

    }, [props.user, date]);

    useEffect(() => {

        if (!props.user) {
            return;
        }

        if (!date) {
            return;
        }

        getIncentiveData();

    }, [props.user, date, incentiveUpdate]);

    useEffect(() => {

        if (!props.user) {
            return;
        }

        if (!date) {
            return;
        }

        getOtherLocationIncentiveData();

    }, [props.user, date, otherIncentiveUpdate]);

    const getOtherLocationIncentiveData = async () => {

        try {

            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            const result: any = await getFetch("/dashboard/salary/getotherlocationincentive?userId=" + props.user.id + "&month=" + month + "&year=" + year);

            if (result.message === "success") {
                setOtherLocationIncentiveData(result.data);

                const totals: { [loc: string]: number } = {};
                result.data.forEach((item: any) => {
                    const loc = item.location;
                    totals[loc] = (totals[loc] ?? 0) + parseInt(item.amount);
                });
                setOtherLocationIncentiveTotals(totals);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getIncentiveData = async () => {

        try {

            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            const result: any = await getFetch("/dashboard/salary/getincentive?userId=" + props.user.id + "&month=" + month + "&year=" + year);

            var totalIncentiveCalc = 0;

            if (result.message === "success") {
                console.log(result.data);
                setIncentiveData(result.data);

                result.data.forEach((item: any) => {

                    const amount = parseInt(item.amount);
                    totalIncentiveCalc += amount;

                });
                setTotalIncentive(totalIncentiveCalc);
            }

        } catch (e) {
            console.log(e);
        }
    }

    const getEmploymentInsurance = async () => {

        try {

            const result: any = await getFetch("/dashboard/salary/getemploymentinsurance?userId=" + props.user.id);

            if (result.message === "success") {
                setEmploymentInsurance(!!result.data);
            } else {
                setEmploymentInsurance(false);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getHolidayPay = async () => {

        try {

            const result: any = await getFetch("/dashboard/salary/getholidaypay?userId=" + props.user.id);

            if (result.message === "success") {
                setHolidayPayApplied(!!result.data);
            } else {
                setHolidayPayApplied(false);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getHolidays = async () => {

        try {

            const result: any = await getFetch("/dashboard/salary/getholidays");

            if (result.message === "success") {
                setHolidays(result.data ?? []);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getMockExams = async () => {

        try {

            const result: any = await getFetch("/dashboard/salary/getmockexamdays");

            if (result.message === "success") {
                setMockExams(result.data ?? []);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getTravelAllowances = async () => {

        try {

            const result: any = await getFetch("/dashboard/salary/gettravelallowances");

            if (result.message === "success") {
                setTravelAllowances(result.data ?? []);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getOtherLocationExtras = async () => {

        try {

            const year = date.getFullYear();
            const month = date.getMonth() + 1;

            const result: any = await getFetch(`/dashboard/salary/getotherlocationextras?userId=${props.user.id}&year=${year}&month=${month}`);

            if (result.message === "success") {
                const map: { [loc: string]: { extraAmount: number; memo: string } } = {};
                result.data.forEach((item: any) => {
                    map[item.location] = { extraAmount: item.extraAmount ?? 0, memo: item.memo ?? "" };
                });
                setOtherLocationExtras(map);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const saveOtherLocationExtra = async () => {

        try {

            setExtraMemoSaveLoading(true);

            const current = otherLocationExtras[extraMemoEditLocation] ?? { extraAmount: 0, memo: "" };
            const extraAmount = extraMemoEditType === "extra" ? (parseInt(extraMemoInputValue) || 0) : current.extraAmount;
            const memo = extraMemoEditType === "memo" ? extraMemoInputValue : current.memo;

            const result: any = await postFetch("/dashboard/salary/setotherlocationextra", {
                userId: props.user.id,
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                location: extraMemoEditLocation,
                extraAmount,
                memo,
            });

            if (result.message === "success") {
                setOtherLocationExtras(prev => ({
                    ...prev,
                    [extraMemoEditLocation]: { extraAmount, memo },
                }));
                setExtraMemoModalOpen(false);
                setExtraMemoInputValue("");
            }

            setExtraMemoSaveLoading(false);

        } catch (e) {
            console.log(e);
        }

    }

    const getWeekPayDays = async () => {

        try {

            const userId = props.user.id;

            const result: any = await getFetch("/dashboard/salary/getweekpaydays?userId=" + userId);

            if (result.message === "success") {
                setSelectedWeekPayDays([...result.data]);
            } else {
                setSelectedWeekPayDays([]);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getUserAccessData = async () => {

        try {

            const calendarStartTime = calendarStart?.getTime();
            const calendarEndTime = calendarEnd?.getTime();

            const result: any = await getFetch("/dashboard/salary/getshopsalaryworkuseraccess?userId=" + props.user.id + "&start=" + calendarStartTime + "&end=" + calendarEndTime);

            console.log(result.data);

            if (result.message === "success") {
                setUserAccessData(result.data);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getUserData = async () => {

        try {

            const calendarStartTime = calendarStart?.getTime();
            const calendarEndTime = calendarEnd?.getTime();

            const result: any = await getFetch("/dashboard/salary/getregisteredshopsalaryworkuser?userId=" + props.user.id + "&start=" + calendarStartTime + "&end=" + calendarEndTime);

            if (result.message === "success") {

                const data = structuredClone(result.data ?? []);
                const manuallyRegisteredJobsData = result.manuallyRegisteredJobs;
                const defaultJobSettings: { english: string, location: string }[] = result.defaultJobSettings;

                manuallyRegisteredJobsData.forEach((item: any) => {

                    const oneData: any = {};

                    oneData.id = item.id;
                    oneData.isManually = true;
                    oneData.targetDate = item.targetDate;
                    oneData.location = item.location;
                    oneData.korean = item.korean;
                    oneData.hourlyWage = item.hoursWage;
                    oneData.realMinutes = item.realMinutes;
                    oneData.startTime = item.startTime;
                    oneData.isDefault = item.isDefault;
                    oneData.isRequested = item.isRequested;

                    data.push(oneData);

                });

                data.forEach((item: any) => {

                    item.notAttended = false;
                    item.late = false;
                    item.earlyLeave = false;
                    item.earlyLeaveMinutes = 0;
                    item.accessItem = null;
                    item.isHeadOfficeRequest = false;

                    const itemEnglish = item.english;
                    const itemLocation = item.location;
                    const targetDate = new Date(item.targetDate);

                    defaultJobSettings.forEach((defaultJobItem: any) => {

                        const defaultLocation = defaultJobItem.location;
                        const defaultEnglish = defaultJobItem.english;

                        if (!defaultLocation || !defaultEnglish) {
                            return;
                        }

                        if (itemLocation === defaultLocation && itemEnglish === defaultEnglish) {
                            console.log("it's default");
                            item.isDefault = true;
                        }

                    });

                    if (!item.isDefault && item.status === 1) {
                        item.isHeadOfficeRequest = true;
                    }

                    if (item.isManually && !item.isDefault && item.isRequested) {
                        item.isHeadOfficeRequest = true;
                    }

                    const itemYear = targetDate.getFullYear();
                    const itemMonth = targetDate.getMonth();
                    const itemDate = targetDate.getDate();

                    item.hourlyWage = !item.isManually ? item.data[itemLocation].hourlyWage : item.hourlyWage;
                    const selectedJobInfo = !item.isManually ? item.data[itemLocation].jobs.find((jobItem: any) => jobItem.english === itemEnglish) : null;

                    if (!selectedJobInfo && !item.isManually) {
                        return;
                    }

                    if (!item.isManually) {
                        const startTime = selectedJobInfo.time.start;
                        const startHours = parseInt(startTime.split(":")[0]);
                        const startMinutes = parseInt(startTime.split(":")[1]);

                        const endTime = selectedJobInfo.time.end;
                        const endHours = parseInt(endTime.split(":")[0]);
                        const endMinutes = parseInt(endTime.split(":")[1]);

                        item.startTotalMinutes = startHours * 60 + startMinutes;
                        item.endTotalMinutes = endHours * 60 + endMinutes;

                        item.selectedJobInfo = selectedJobInfo;
                    } else {
                        const startTime = item.startTime;
                        const startHours = parseInt(startTime.split(":")[0]);
                        const startMinutes = parseInt(startTime.split(":")[1]);

                        item.startTotalMinutes = startHours * 60 + startMinutes;
                        item.endTotalMinutes = 24 * 60;
                    }


                    userAccessData?.forEach((accessItem: any) => {
                        const accessDate = new Date(accessItem.DateInserted);

                        const accessYear = accessDate.getFullYear();
                        const accessMonth = accessDate.getMonth();
                        const accessDay = accessDate.getDate();

                        var isSame = false;

                        if (itemYear === accessYear && itemMonth === accessMonth && itemDate === accessDay) {
                            isSame = true;
                        }

                        if (isSame) {
                            item.accessItem = accessItem;
                        }

                    });
                });

                // 출석 처리 (realMinutes, notAttended, late 확정)
                data.forEach((item: any) => {

                    const selectedJobInfo = !item.isManually ? item.selectedJobInfo : {
                        time: {
                            start: item.startTime,
                            end: "24:00",
                        },
                        realMinutes: item.realMinutes,
                    };


                    const accessItem = item.accessItem;

                    if (!accessItem) {
                        item.notAttended = true;
                        item.realMinutes = 0;
                        return;
                    }

                    const accessDate = new Date(accessItem.DateInserted);

                    const accessHours = accessDate.getHours();
                    const accessMinutes = accessDate.getMinutes();

                    const accessTotalMinutes = accessHours * 60 + accessMinutes;

                    const selectedJobInfoStart = selectedJobInfo.time.start;

                    const selectedJobInfoStartHours = parseInt(selectedJobInfoStart.split(":")[0]);
                    const selectedJobInfoStartMinutes = parseInt(selectedJobInfoStart.split(":")[1]);

                    const selectedJobInfoStartTotalMinutes = selectedJobInfoStartHours * 60 + selectedJobInfoStartMinutes;

                    const selectedJobInfoEnd = selectedJobInfo.time.end;

                    const selectedJobInfoEndHours = parseInt(selectedJobInfoEnd.split(":")[0]);
                    const selectedJobInfoEndMinutes = parseInt(selectedJobInfoEnd.split(":")[1]);

                    const selectedJobInfoEndTotalMinutes = selectedJobInfoEndHours * 60 + selectedJobInfoEndMinutes;

                    item.realMinutes = selectedJobInfo.realMinutes;

                    if (accessTotalMinutes > selectedJobInfoStartTotalMinutes) {
                        item.late = true;
                        const gap = accessTotalMinutes - selectedJobInfoStartTotalMinutes;
                        item.realMinutes = item.realMinutes - gap;
                    }

                    if (accessTotalMinutes > selectedJobInfoEndTotalMinutes) {
                        item.notAttended = true;
                        item.realMinutes = 0;
                    }

                    // 조퇴 차감 : 마지막 출입 태그가 근무 종료시간보다 이르면 그 차이만큼 차감 (2026년 7월 10일 근무분부터)
                    if (
                        !item.isManually &&
                        !item.notAttended &&
                        accessItem.lastDateInserted &&
                        new Date(item.targetDate).getTime() >= EARLY_LEAVE_DEDUCTION_START.getTime()
                    ) {
                        const lastAccessDate = new Date(accessItem.lastDateInserted);

                        var lastTotalMinutes = lastAccessDate.getHours() * 60 + lastAccessDate.getMinutes();

                        // 마지막 태그가 자정을 넘어 익일 새벽인 경우(마감 태그) +24시간 처리
                        if (lastAccessDate.getDate() !== accessDate.getDate()) {
                            lastTotalMinutes = lastTotalMinutes + 24 * 60;
                        }

                        if (lastTotalMinutes < selectedJobInfoEndTotalMinutes) {
                            item.earlyLeave = true;
                            item.earlyLeaveMinutes = selectedJobInfoEndTotalMinutes - lastTotalMinutes;
                            item.realMinutes = item.realMinutes - item.earlyLeaveMinutes;
                        }
                    }

                    if (item.realMinutes < 0) {
                        item.realMinutes = 0;
                    }

                });

                // 본인 지점 / 타지점 분리
                const homeData = data.filter((item: any) =>
                    isSameLocationGroup(item.location, props.user.location)
                );
                const otherDataAll = data.filter((item: any) =>
                    !isSameLocationGroup(item.location, props.user.location)
                );

                // 본인 지점 급여 합산
                var totalHoursWageCalc = 0;
                var totalNightPayCalc = 0;
                var totalHolidayPayCalc = 0;
                var totalMockExamIncentiveCalc = 0;

                homeData.forEach((item: any) => {
                    const itemMonth = new Date(item.targetDate).getMonth();
                    const itemYear = new Date(item.targetDate).getFullYear();
                    const dateMonth = date.getMonth();
                    const dateYear = date.getFullYear();

                    if (itemMonth === dateMonth && itemYear === dateYear) {
                        const hourlyWage = item.hourlyWage;
                        const minuteWage = Math.ceil((hourlyWage / 60) * 10) / 10;
                        const realMinutes = item.realMinutes;
                        const wage = minuteWage * realMinutes;
                        totalHoursWageCalc += wage;

                        if (!item.notAttended && !item.isManually) {
                            const nightWorkMins = item.selectedJobInfo?.nightWorkMinutes ?? 0;
                            if (nightWorkMins > 0) {
                                totalNightPayCalc += Math.floor(hourlyWage * (nightWorkMins / 2) / 60);
                            }
                        }

                        // 공휴일 수당: 적용 on + 담당 근무 + 실제 근무 + 그날이 공휴일
                        // (수동 등록이어도 isDefault면 담당 근무이므로 포함)
                        if (holidayPayApplied && item.isDefault && !item.notAttended) {
                            const holiday = findHoliday(new Date(item.targetDate));
                            if (holiday) {
                                totalHolidayPayCalc += Math.floor(minuteWage * realMinutes * parseFloat(holiday.multiplier));
                            }
                        }

                        // 모의고사 인센티브: 모의고사 날 + 현재 설정에서 O인 직책 근무 (대타 포함, 담당 여부 무관)
                        if (findMockExam(new Date(item.targetDate))) {
                            totalMockExamIncentiveCalc += getMockExamIncentiveAmount(item);
                        }
                    }
                });

                // 타지점 급여 합산 (지점별)
                const newOtherLocationWages: { [loc: string]: number } = {};
                const newOtherLocationMockExamIncentives: { [loc: string]: number } = {};
                const newOtherLocationTravelAllowances: { [loc: string]: number } = {};
                const uniqueOtherLocs: string[] = Array.from(new Set(otherDataAll.map((item: any) => item.location as string)));

                uniqueOtherLocs.forEach((loc: string) => {
                    const locData = otherDataAll.filter((item: any) => item.location === loc);
                    var locWage = 0;
                    var locMockExamIncentive = 0;
                    var locTravelAllowance = 0;
                    const travelPaidDays = new Set<string>();

                    locData.forEach((item: any) => {
                        const itemMonth = new Date(item.targetDate).getMonth();
                        const itemYear = new Date(item.targetDate).getFullYear();
                        const dateMonth = date.getMonth();
                        const dateYear = date.getFullYear();

                        if (itemMonth === dateMonth && itemYear === dateYear) {
                            const hourlyWage = item.hourlyWage;
                            const minuteWage = Math.ceil((hourlyWage / 60) * 10) / 10;
                            locWage += minuteWage * item.realMinutes;

                            // 모의고사 인센티브: 타지점 근무도 지급 (대타 포함, 담당 여부 무관)
                            if (findMockExam(new Date(item.targetDate))) {
                                locMockExamIncentive += getMockExamIncentiveAmount(item);
                            }

                            // 출장비: 승인된 본사요청 대타만, 하루 1회 (같은 날 같은 지점 중복 지급 없음)
                            const travelAmount = getTravelAllowanceAmount(item);
                            if (travelAmount > 0) {
                                const travelDayKey = dateToHolidayKey(new Date(item.targetDate));
                                if (!travelPaidDays.has(travelDayKey)) {
                                    locTravelAllowance += travelAmount;
                                    travelPaidDays.add(travelDayKey);
                                }
                            }
                        }
                    });

                    newOtherLocationWages[loc] = Math.ceil(locWage);
                    newOtherLocationMockExamIncentives[loc] = locMockExamIncentive;
                    newOtherLocationTravelAllowances[loc] = locTravelAllowance;
                });

                // 주휴수당 계산 (본인 지점 + 타지점 각각 독립 계산)
                // 타지점은 해당 지점에서만 selectedWeekPayDays 필수 요일을 채워야 주휴수당 지급
                if (selectedWeekPayDays.length > 0) {
                    // 본인 지점 주휴수당
                    const homeWeekPay = calculateWeekPayForData(homeData, selectedWeekPayDays, date);
                    setHomeWeekPayDataArray([...homeWeekPay.weekPayDataArray]);
                    setTotalWeekPay(homeWeekPay.totalWeekPay);

                    // 타지점별 주휴수당
                    const newOtherWeekPayArrays: { [loc: string]: any[] } = {};

                    uniqueOtherLocs.forEach((loc: string) => {
                        const locData = otherDataAll.filter((item: any) => item.location === loc);
                        const locWeekPay = calculateWeekPayForData(locData, selectedWeekPayDays, date);
                        newOtherWeekPayArrays[loc] = locWeekPay.weekPayDataArray;
                        // 주휴수당을 타지점 급여에 합산
                        newOtherLocationWages[loc] = (newOtherLocationWages[loc] ?? 0) + locWeekPay.totalWeekPay;
                    });

                    setOtherWeekPayDataArrays(newOtherWeekPayArrays);
                } else {
                    setHomeWeekPayDataArray([]);
                    setTotalWeekPay(0);
                    setOtherWeekPayDataArrays({});
                }

                setOtherLocationWages(newOtherLocationWages);
                setOtherLocationMockExamIncentives(newOtherLocationMockExamIncentives);
                setOtherLocationTravelAllowances(newOtherLocationTravelAllowances);

                totalHoursWageCalc = Math.ceil(totalHoursWageCalc);

                setTotalHoursWage(totalHoursWageCalc);
                setTotalNightPay(totalNightPayCalc);
                setTotalHolidayPay(totalHolidayPayCalc);
                setTotalMockExamIncentive(totalMockExamIncentiveCalc);
                setHomeUserData(homeData);
                setOtherUserData(otherDataAll);
                setUserData(data);

                console.log("userData");
                console.log(data);
            }

        } catch (e) {
            console.log(e);
        }

    }

    const getData = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/salary/getshopsalaryconfigAll");

            if (result.message === "success") {
                setData(result.data);
            }

            setLoading(false);
            console.log(result);

        } catch (e) {
            console.log(e);
        }

    }

    const handleMonth = (direction: string) => {
        if (direction === "left") {
            const newDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
            setDate(newDate);
        } else {
            const today = new Date();
            const todayYear = today.getFullYear();
            const todayMonth = today.getMonth();

            if (date.getMonth() >= todayMonth && date.getFullYear() >= todayYear) {
                return;
            }

            const newDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            setDate(newDate);
        }
    };

    const makeCalendar = () => {
        const start = new Date(date.getFullYear(), date.getMonth(), 1);
        const monthFirstDay = start.getDay();

        start.setDate(start.getDate() - monthFirstDay);

        const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        const monthLastDay = end.getDay();

        end.setDate(end.getDate() + (6 - monthLastDay));

        setCalendarStart(start);
        setCalendarEnd(end);
    };

    useEffect(() => {
        makeCalendar();
    }, [date]);

    const isSameDate = (a: Date, b: Date) =>
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();

    // 공휴일 매칭 키 — 서버가 내려주는 targetDate("YYYY-MM-DD" 문자열)와 로컬 날짜 기준으로 비교
    const dateToHolidayKey = (d: Date) =>
        `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

    const findHoliday = (d: Date) =>
        holidays.find((h: any) => h.targetDate === dateToHolidayKey(d)) ?? null;

    const findMockExam = (d: Date) =>
        mockExams.find((m: any) => m.targetDate === dateToHolidayKey(d)) ?? null;

    // 모의고사 인센티브 금액 — 등록 시점 스냅샷(work.data)이 아닌 현재 업무 설정(data state) 기준이라 설정 변경이 기존 등록 근무에도 소급 적용됨
    // (수동 등록 근무는 근무 종류(english)를 알 수 없어 제외, 대타·담당 여부는 무관)
    const getMockExamIncentiveAmount = (work: any) => {
        if (work.isManually || work.notAttended || !data) {
            return 0;
        }
        const jobConfig = data[work.location]?.jobs?.find((j: any) => j.english === work.english);
        if (jobConfig?.mockExamIncentive && +(jobConfig.mockExamIncentiveAmount ?? 0) > 0) {
            return +jobConfig.mockExamIncentiveAmount;
        }
        return 0;
    };

    // 출장비 매트릭스 조회용 지점명 정규화 — 대치 그룹(대치점/대치3층/대치6층)은 "대치점"으로 통일
    const travelDepartureToKorean = (koreanLocation: string) => {
        const eng = koreanLocationToEnglish(koreanLocation);
        if (eng && DAECHI_GROUP_ENG.includes(eng)) {
            return englishLocationToKorean("daechi") ?? koreanLocation;
        }
        return koreanLocation;
    };

    const travelArrivalToKorean = (englishLocation: string) => {
        if (DAECHI_GROUP_ENG.includes(englishLocation)) {
            return englishLocationToKorean("daechi");
        }
        return englishLocationToKorean(englishLocation);
    };

    // 출장비 — 본인 지점(studentLocation, 한글) → 근무 지점 경로로 travelAllowance 매트릭스 조회
    // 승인된 본사요청 대타 + 실제 근무(결근 제외)만 지급, 경로 미등록이면 0원
    const getTravelAllowanceAmount = (work: any) => {
        if (!work.isHeadOfficeRequest || work.notAttended) {
            return 0;
        }
        if (!props.user || !props.user.location) {
            return 0;
        }
        const departure = travelDepartureToKorean(props.user.location);
        const arrival = travelArrivalToKorean(work.location);
        if (!arrival) {
            return 0;
        }
        const row = travelAllowances.find((t: any) => t.departureLocation === departure && t.arrivalLocation === arrival);
        return row ? +row.substituteAllowance : 0;
    };

    // 그날 출장비 합계 — 하루 1회(같은 지점 중복 지급 없음, 다른 지점은 각각)
    const getDayTravelAllowance = (day: Date, works: any[] | null) => {
        if (!works) {
            return 0;
        }
        const paidLocs = new Set<string>();
        var sum = 0;
        works.forEach((work: any) => {
            if (!isSameDate(new Date(work.targetDate), day)) {
                return;
            }
            if (paidLocs.has(work.location)) {
                return;
            }
            const amount = getTravelAllowanceAmount(work);
            if (amount > 0) {
                sum += amount;
                paidLocs.add(work.location);
            }
        });
        return sum;
    };

    const getCalendarMatrix = (): Date[][] => {
        if (!calendarStart || !calendarEnd) return [];

        const days: Date[] = [];
        const cur = new Date(calendarStart);

        while (cur <= calendarEnd) {
            days.push(new Date(cur));
            cur.setDate(cur.getDate() + 1);
        }

        const weeks: Date[][] = [];
        for (let i = 0; i < days.length; i += 7) {
            weeks.push(days.slice(i, i + 7));
        }
        return weeks;
    };

    const today = new Date();
    const weeks = getCalendarMatrix();

    const handleCellClick = (day: Date) => {
        setSelectedDate(day);
        setModalCalendarType("home");
        setModalOpen(true);
    }

    const handleCellClick2 = (day: Date) => {
        setSelectedDate(day);
        setModalCalendarType("other");
        setModalOpen(true);
    }

    const handleClose5 = () => {
        setAnchorEl(null);
        setSelectedWorkId(null);
        setIsDefault(true);
        setIsManually(false);
    }

    const handleClose6 = () => {
        setAnchorEl2(null);
        setSelectedDate(null);
    }

    const handleDelete = async () => {

        if (!window.confirm("정말로 선택한 업무를 삭제하시겠습니까?")) {
            handleClose5();
            return;
        }

        try {

            if (!selectedWorkId) {
                return;
            }

            setCentorLoading(true);

            const result: any = await postFetch("/dashboard/salary/deleteshopsalarywork", {
                workId: selectedWorkId,
                isManually: isManually,
            });

            console.log(result);

            if (result.message === "success") {
                console.log("success");
                handleClose5();
                setUpdate(Math.random());
            }

            setCentorLoading(false);

        } catch (e) {
            console.log(e);
        }

    }

    const handleRightClick = (e: any, workId: number, isDefault: boolean, isManually: boolean) => {

        e.preventDefault();
        e.stopPropagation();

        console.log(workId);

        setSelectedWorkId(workId);
        setAnchorEl(e.currentTarget);
        setIsDefault(isDefault);
        setIsManually(isManually);

    }

    const handleRightClick2 = (e: any, day: Date, calType: "home" | "other") => {

        e.preventDefault();
        e.stopPropagation();

        setSelectedDate(day);
        setModalCalendarType(calType);
        setAnchorEl2(e.currentTarget);

    }

    const requestHeadOffice = async (workId: number) => {

        if (!window.confirm("해당 대타 근무가 본사 요청 근무가 맞습니까?")) {
            return;
        }

        try {

            setCentorLoading(true);

            const result: any = await postFetch("/dashboard/salary/requestheadofficeforwork", {
                workId: workId,
            });

            setCentorLoading(false);

            if (result.message === "DUPLICATE") {
                props.notify("error", "이미 본사에 인증 요청된 대타 근무입니다.");
                return;
            }

            if (result.message === "success") {
                props.notify("success", "본사 요청 대타 근무 인증 요청을 보냈습니다.");
                handleClose5();
            }

        } catch (e) {
            console.log(e);
        }

    }

    const registerWorkManually = () => {

        if (!selectedDate) {
            return;
        }

        setAnchorEl2(null);

        setModalOpen6(true);

    }

    useEffect(() => {

        console.log(selectedWeekPayDays);

    }, [selectedWeekPayDays])

    // 타지점 결과표에 표시할 지점 목록 (본인 지점 그룹 제외)
    const getOtherLocationList = () => {
        return totalLocationData.filter((loc) => {
            if (!loc.academy.includes("sunbae") && !loc.academy.includes("bundangsunbae")) return false;
            if (loc.english === "total") return false;
            if (!props.user) return true;
            return !isSameLocationGroup(loc.english, props.user.location);
        });
    };

    const otherLocationList = getOtherLocationList();

    const renderWorkItems = (day: Date, filteredUserData: any[] | null, calType: "home" | "other") => {
        if (!filteredUserData || !data) return null;

        return filteredUserData.map((work: any, index: number) => {
            const calendarYear = day.getFullYear();
            const calendarMonth = day.getMonth() + 1;
            const calendarDate = day.getDate();

            const workDate = new Date(work.targetDate);
            const workYear = workDate.getFullYear();
            const workMonth = workDate.getMonth() + 1;
            const workDay = workDate.getDate();
            const workLocation = work.location;

            var isSame = false;

            if (calendarYear === workYear && calendarMonth === workMonth && calendarDate === workDay) {
                isSame = true;
            }

            if (!isSame) {
                return null;
            }

            const jobData = !work.isManually ? work.data[workLocation].jobs.find((jobItem: any) => jobItem.english === work.english) : {
                korean: work.korean,
            };

            if (!jobData) {
                return null;
            }

            const nightWorkMins = jobData?.nightWorkMinutes ?? 0;
            const nightWage = (!work.notAttended && nightWorkMins > 0)
                ? Math.floor(work.hourlyWage * (nightWorkMins / 2) / 60)
                : 0;

            // 공휴일 수당 표기 (본인 지점 + 수당 적용 on + 담당 근무 + 실제 근무 + 공휴일)
            const holiday = calType === "home" ? findHoliday(workDate) : null;
            const holidayWage = (holidayPayApplied && work.isDefault && !work.notAttended && holiday)
                ? Math.floor((Math.ceil((work.hourlyWage / 60) * 10) / 10) * work.realMinutes * parseFloat(holiday.multiplier))
                : 0;

            // 모의고사 인센티브 표기 (본인지점·타지점 모두, 대타 포함)
            const mockExamIncentiveWage = findMockExam(workDate) ? getMockExamIncentiveAmount(work) : 0;

            return (
                <div key={index} style={{
                    backgroundColor: work.isManually ? "black" : work.notAttended ? "red" : work.late ? "#FAB38D" : work.earlyLeave ? "#F6D9A0" : "#C2DDF5",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    fontWeight: 500,
                    borderRadius: "4px",
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "4px",
                    fontSize: "15px",
                    color: work.isManually ? "white" : (!work.isDefault && work.isHeadOfficeRequest) ? "#004EA2" : "black",
                }}
                    onContextMenu={(e: any) => {
                        handleRightClick(e, work.id, work.isDefault, work.isManually);
                    }}
                >
                    {work.isDefault ? "" : work.isHeadOfficeRequest ? "[본사요청 대타] " : "[대타] "} [{englishLocationToKorean(workLocation)}] {jobData.korean} - {Math.floor(work.realMinutes / 60)}시간 {work.realMinutes % 60}분{work.earlyLeave ? ` (조퇴 -${work.earlyLeaveMinutes}분)` : ""}{nightWage > 0 ? ` (추가 야간 수당 ${nightWage.toLocaleString()}원)` : ""}{holidayWage > 0 ? ` (공휴일 수당 ${holidayWage.toLocaleString()}원)` : ""}{mockExamIncentiveWage > 0 ? ` (모의고사 인센티브 ${mockExamIncentiveWage.toLocaleString()}원)` : ""}
                </div>
            );
        });
    };

    const renderWeekPayItems = (day: Date, weekPayDataArr: any[]) => {
        if (!weekPayDataArr || weekPayDataArr.length === 0) return null;

        return weekPayDataArr.map((weekPayItem: any, index: number) => {
            if (!weekPayItem.isWeekPayDay) {
                return null;
            }

            const sundayDate = new Date(weekPayItem.sundayDate);
            const sundayYear = sundayDate.getFullYear();
            const sundayMonth = sundayDate.getMonth();
            const sundayDay = sundayDate.getDate();

            if (sundayYear === day.getFullYear() && sundayMonth === day.getMonth() && sundayDay === day.getDate()) {
                return (
                    <div key={index} style={{
                        backgroundColor: "#A3D8B8",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        fontWeight: 500,
                        borderRadius: "4px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginBottom: "4px",
                        fontSize: "14px",
                    }}>
                        <div style={{ fontWeight: 700, marginBottom: "6px" }}>
                            주휴수당 지급
                        </div>
                        <div>
                            {Math.floor(weekPayItem.minutes / 60)}시간 {weekPayItem.minutes % 60}분 근무
                        </div>
                        <div>
                            ({weekPayItem.wage.toLocaleString()}원)
                        </div>
                    </div>
                );
            }
            return null;
        });
    };

    const renderOtherWeekPayItems = (day: Date) => {
        return Object.entries(otherWeekPayDataArrays).map(([locEng, weekPayArr]) => {
            return weekPayArr.map((weekPayItem: any, idx: number) => {
                if (!weekPayItem.isWeekPayDay) return null;

                const sundayDate = new Date(weekPayItem.sundayDate);

                if (isSameDate(sundayDate, day)) {
                    return (
                        <div key={`${locEng}_${idx}`} style={{
                            backgroundColor: "#A3D8B8",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            fontWeight: 500,
                            borderRadius: "4px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginBottom: "4px",
                            fontSize: "14px",
                        }}>
                            <div style={{ fontWeight: 700, marginBottom: "6px" }}>
                                [{englishLocationToKorean(locEng)}] 주휴수당 지급
                            </div>
                            <div>
                                {Math.floor(weekPayItem.minutes / 60)}시간 {weekPayItem.minutes % 60}분 근무
                            </div>
                            <div>
                                ({weekPayItem.wage.toLocaleString()}원)
                            </div>
                        </div>
                    );
                }
                return null;
            });
        });
    };

    const renderCalendarCell = (
        day: Date,
        inThisMonth: boolean,
        isTodayCell: boolean,
        filteredUserData: any[] | null,
        weekPayArr: any[] | null,
        calType: "home" | "other"
    ) => {
        const holidayCell = findHoliday(day);

        // 실제 공휴일 수당이 발생하는 날만 달력에 공휴일 표시 (수당 없으면 일반 날짜와 동일)
        const hasHolidayPay = !!(
            holidayCell &&
            holidayPayApplied &&
            calType === "home" &&
            filteredUserData &&
            filteredUserData.some((work: any) =>
                isSameDate(new Date(work.targetDate), day) && work.isDefault && !work.notAttended
            )
        );

        // 실제 모의고사 인센티브가 발생하는 날만 달력에 모의고사 표시 (본인지점·타지점 캘린더 모두)
        const mockExamCell = findMockExam(day);
        const hasMockExamIncentive = !!(
            mockExamCell &&
            filteredUserData &&
            filteredUserData.some((work: any) =>
                isSameDate(new Date(work.targetDate), day) && getMockExamIncentiveAmount(work) > 0
            )
        );

        // 출장비 발생일만 표시 (타지점 캘린더만, 하루 1회 정책이라 날짜당 1줄)
        const dayTravelAllowance = calType === "other" ? getDayTravelAllowance(day, filteredUserData) : 0;

        return (
            <td
                className={styles.calendarTd}
                style={{
                    height: "150px",
                    verticalAlign: "top",
                    border: "1px solid #e0e0e0",
                    backgroundColor: inThisMonth ? "white" : "#f7f7f7",
                    padding: "4px 6px",
                    cursor: "pointer"
                }}
                onClick={() => {
                    if (calType === "home") {
                        handleCellClick(day);
                    } else {
                        handleCellClick2(day);
                    }
                }}
                onContextMenu={(e) => {
                    if (!props.forManager) {
                        return;
                    }
                    handleRightClick2(e, day, calType);
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <div>
                        {
                            userAccessData
                                ?
                                userAccessData.map((accessItem: any, index: number) => {
                                    const accessDate = new Date(accessItem.DateInserted);
                                    const accessDateForDay = new Date(accessItem.DateInserted);

                                    accessDateForDay.setHours(accessDateForDay.getHours() - 2);

                                    const accessYear = accessDateForDay.getFullYear();
                                    const accessMonth = accessDateForDay.getMonth();
                                    const accessDay = accessDateForDay.getDate();
                                    if (accessYear === day.getFullYear() && accessMonth === day.getMonth() && accessDay === day.getDate()) {
                                        return (
                                            <React.Fragment key={index}>
                                                <span style={{
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                    marginRight: "4px",
                                                    border: "1px solid #3d50b0",
                                                    padding: "2px 4px",
                                                    borderRadius: "4px",
                                                    color: "#3d50b0",
                                                }}>
                                                    {
                                                        dateToDateString(accessDate, true, true)
                                                    }
                                                </span>
                                                {
                                                    // 퇴근(마지막) 태그 시간 배지 - 조퇴 차감 근거 확인용
                                                    accessItem.lastDateInserted && accessItem.lastDateInserted !== accessItem.DateInserted
                                                    &&
                                                    <span style={{
                                                        fontSize: "13px",
                                                        fontWeight: 500,
                                                        marginRight: "4px",
                                                        border: "1px solid #b0563d",
                                                        padding: "2px 4px",
                                                        borderRadius: "4px",
                                                        color: "#b0563d",
                                                    }}>
                                                        {
                                                            dateToDateString(new Date(accessItem.lastDateInserted), true, true)
                                                        }
                                                    </span>
                                                }
                                            </React.Fragment>
                                        )
                                    }
                                })
                                :
                                ""
                        }
                    </div>
                    <div
                        style={{
                            width: 24,
                            height: 24,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: (isTodayCell || hasHolidayPay) ? 700 : 400,
                            backgroundColor: isTodayCell ? "#007aff" : "transparent",
                            color: isTodayCell ? "white" : hasHolidayPay ? (inThisMonth ? "red" : "#e5a0a0") : inThisMonth ? "black" : "#b0b0b0",
                        }}
                    >
                        {day.getDate()}
                    </div>
                </div>

                <div style={{ height: "8px" }} />

                {
                    hasHolidayPay &&
                    <div style={{ color: "red", fontSize: "13px", fontWeight: 600, marginBottom: "4px" }}>
                        {holidayCell.name} (수당 {parseFloat(holidayCell.multiplier)}배)
                    </div>
                }

                {
                    hasMockExamIncentive &&
                    <div style={{ color: "#1a56db", fontSize: "13px", fontWeight: 600, marginBottom: "4px" }}>
                        {mockExamCell.name}
                    </div>
                }

                {
                    dayTravelAllowance > 0 &&
                    <div style={{ color: "#8e24aa", fontSize: "13px", fontWeight: 600, marginBottom: "4px" }}>
                        출장비 {dayTravelAllowance.toLocaleString()}원
                    </div>
                }

                {renderWorkItems(day, filteredUserData, calType)}

                {calType === "home" && weekPayArr && renderWeekPayItems(day, weekPayArr)}
                {calType === "other" && renderOtherWeekPayItems(day)}
            </td>
        );
    };

    return (
        <div>
            <div style={{ height: "32px" }} />

            {/* 탭 토글 */}
            <div style={{ paddingLeft: "8px", paddingRight: "30px", minWidth: "1500px", marginBottom: "20px" }}>
                <ToggleButtonGroup
                    value={activeTab}
                    exclusive
                    onChange={(_e: any, val: "home" | "other") => { if (val) setActiveTab(val); }}
                >
                    <ToggleButton value="home" style={{ fontWeight: 600, fontSize: "15px", padding: "8px 24px" }}>
                        본인 지점 근무 등록
                    </ToggleButton>
                    <ToggleButton value="other" style={{ fontWeight: 600, fontSize: "15px", padding: "8px 24px" }}>
                        타 지점 근무 등록
                    </ToggleButton>
                </ToggleButtonGroup>
            </div>

            <div className={styles.calendarDiv} style={{ width: "100%", paddingRight: "30px", minWidth: "1500px" }}>
                {/* 상단 바 */}
                <div
                    className={styles.calendarTitle}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px",
                        justifyContent: "space-between",
                    }}
                >
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                    }}>
                        <div>
                            <ChevronLeftOutlined
                                fontSize="large"
                                onClick={() => handleMonth("left")}
                                style={{ cursor: "pointer" }}
                            />
                            <ChevronRightOutlined
                                fontSize="large"
                                onClick={() => handleMonth("right")}
                                style={{
                                    cursor:
                                        date.getMonth() >= today.getMonth() &&
                                            date.getFullYear() >= today.getFullYear()
                                            ? "not-allowed"
                                            : "pointer",
                                    color:
                                        date.getMonth() >= today.getMonth() &&
                                            date.getFullYear() >= today.getFullYear()
                                            ? "#d3d3d3"
                                            : "black",
                                }}
                            />
                        </div>
                        <div
                            style={{
                                fontSize: "20px",
                                marginLeft: "18px",
                            }}
                        >
                            {date.getFullYear()}년 {date.getMonth() + 1}월
                        </div>
                    </div>
                    {activeTab === "home" && (
                        <div>
                            <Button
                                variant="outlined"
                                style={{ marginRight: "8px" }}
                                onClick={() => setModalOpen4(true)}
                            >
                                메모
                            </Button>
                            <Button
                                variant="outlined"
                                style={{ marginRight: "8px" }}
                                onClick={() => setModalOpen2(true)}
                            >
                                주휴수당 설정
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={() => setModalOpen3(true)}
                                style={{ marginRight: "8px" }}
                            >
                                인센티브 추가
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={() => setModalOpen5(true)}
                            >
                                담당 근무 설정
                            </Button>
                            <Button
                                variant="outlined"
                                style={{ marginLeft: "8px" }}
                                onClick={() => setModalOpen8(true)}
                            >
                                고용보험
                            </Button>
                            {
                                props.forManager
                                    ?
                                    <Button
                                        variant="outlined"
                                        style={{ marginLeft: "8px" }}
                                        onClick={() => setModalOpen9(true)}
                                    >
                                        공휴일 수당
                                    </Button>
                                    :
                                    ""
                            }
                        </div>
                    )}
                    {activeTab === "other" && (
                        <div>
                            <Button
                                variant="outlined"
                                onClick={() => setOtherIncentiveModalOpen(true)}
                            >
                                인센티브 관리
                            </Button>
                        </div>
                    )}
                </div>

                {
                    loading ?
                        <div>
                            <LinearProgress />
                        </div>
                        : ""
                }

                {/* 달력 (activeTab에 따라 home/other 전환) */}
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                        <tr>
                            <th className={styles.calendarTh}>일요일</th>
                            <th className={styles.calendarTh}>월요일</th>
                            <th className={styles.calendarTh}>화요일</th>
                            <th className={styles.calendarTh}>수요일</th>
                            <th className={styles.calendarTh}>목요일</th>
                            <th className={styles.calendarTh}>금요일</th>
                            <th className={styles.calendarTh}>토요일</th>
                        </tr>
                    </thead>
                    <tbody>
                        {weeks.map((week, wi) => (
                            <tr key={wi}>
                                {week.map((day, di) => {
                                    const inThisMonth = day.getMonth() === date.getMonth();
                                    const isTodayCell = isSameDate(day, today);
                                    return (
                                        <React.Fragment key={di}>
                                            {activeTab === "home"
                                                ? renderCalendarCell(day, inThisMonth, isTodayCell, homeUserData, homeWeekPayDataArray, "home")
                                                : renderCalendarCell(day, inThisMonth, isTodayCell, otherUserData, null, "other")
                                            }
                                        </React.Fragment>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* 결과표 (activeTab에 따라 전환) */}
            {activeTab === "home" && (/* 결과표 1: 본인 지점 */
            <div style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                paddingRight: "30px",
                minWidth: "1500px"
            }}>
                <div
                    style={{
                        width: "420px",
                        borderRadius: "5px",
                        padding: "12px 0",
                        fontFamily:
                            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                    }}
                >
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                            <tr style={{ borderBottom: "1px solid #e0e0e0" }}>
                                <td style={{ padding: "12px 18px", fontSize: "18px", color: "#555" }}>
                                    근무 급여
                                </td>
                                <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "right" }}>
                                    {totalHoursWage.toLocaleString()}원
                                </td>
                            </tr>

                            <tr style={{ borderBottom: "1px solid #ececec" }}>
                                <td style={{ padding: "12px 18px", fontSize: "18px", color: "#555" }}>
                                    주휴 수당
                                </td>
                                <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "right" }}>
                                    {totalWeekPay.toLocaleString()}원
                                </td>
                            </tr>

                            <tr style={{ borderBottom: "1px solid #ececec" }}>
                                <td style={{ padding: "12px 18px", fontSize: "18px", color: "#555" }}>
                                    인센티브
                                </td>
                                <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "right" }}>
                                    {totalIncentive.toLocaleString()}원
                                </td>
                            </tr>

                            {
                                totalMockExamIncentive > 0
                                    ?
                                    <tr style={{ borderBottom: "1px solid #ececec" }}>
                                        <td style={{ padding: "12px 18px", fontSize: "18px", color: "#555" }}>
                                            모의고사 인센티브
                                        </td>
                                        <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "right" }}>
                                            {totalMockExamIncentive.toLocaleString()}원
                                        </td>
                                    </tr>
                                    :
                                    ""
                            }

                            <tr style={{ borderBottom: "1px solid #ececec" }}>
                                <td style={{ padding: "12px 18px", fontSize: "18px", color: "#555" }}>
                                    야간 수당
                                </td>
                                <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "right" }}>
                                    {totalNightPay.toLocaleString()}원
                                </td>
                            </tr>

                            <tr style={{ borderBottom: "1px solid #ececec" }}>
                                <td style={{ padding: "12px 18px", fontSize: "18px", color: "#555" }}>
                                    공휴일 수당
                                </td>
                                <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "right" }}>
                                    {totalHolidayPay.toLocaleString()}원
                                </td>
                            </tr>

                            <tr>
                                <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#555" }}>
                                    총 합계
                                </td>
                                <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "right" }}>
                                    {totalSalary.toLocaleString()}원
                                </td>
                            </tr>

                            {
                                employmentInsurance
                                    ?
                                    <tr style={{ borderBottom: "1px solid #ececec" }}>
                                        <td style={{ padding: "12px 18px", fontSize: "18px", color: "#555" }}>
                                            <div style={{ whiteSpace: "nowrap" }}>
                                                근로소득세 (간이세액표)
                                            </div>
                                        </td>
                                        <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "right" }}>
                                            {incomeTax > 0 ? `-${incomeTax.toLocaleString()}` : "0"}원
                                        </td>
                                    </tr>
                                    :
                                    ""
                            }

                            <tr style={{ borderBottom: "1px solid #ececec" }}>
                                <td style={{ padding: "12px 18px", fontSize: "18px", color: "#555" }}>
                                    {employmentInsurance ? "고용보험 (0.9%)" : "세금 (3.3%)"}
                                </td>
                                <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, textAlign: "right", color: "#333" }}>
                                    -{tax.toLocaleString()}원
                                </td>
                            </tr>

                            <tr>
                                <td style={{ padding: "12px 18px", fontSize: "18px", fontWeight: 500, color: "#111" }}>
                                    세후 금액
                                </td>
                                <td style={{ padding: "12px 18px", fontSize: "20px", fontWeight: 700, color: "#000", textAlign: "right" }}>
                                    {afterTax.toLocaleString()}원
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            )}

            {activeTab === "other" && (
            <div>
            {/* 결과표 2: 타지점별 */}
            <div style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                paddingRight: "30px",
                minWidth: "1500px",
                marginTop: "8px",
            }}>
                <div style={{
                    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                }}>
                    <table style={{ borderCollapse: "collapse" }}>
                        <colgroup>
                            <col style={{ width: "90px" }} />
                            <col style={{ width: "120px" }} />
                            <col style={{ width: "130px" }} />
                            <col style={{ width: "120px" }} />
                            <col style={{ width: "140px" }} />
                            <col style={{ width: "120px" }} />
                            <col style={{ width: "280px" }} />
                            <col style={{ width: "100px" }} />
                            <col style={{ width: "110px" }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th style={{ padding: "10px 16px", fontSize: "15px", fontWeight: 600, border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", textAlign: "center", whiteSpace: "nowrap" }}>
                                    지점
                                </th>
                                <th style={{ padding: "10px 16px", fontSize: "15px", fontWeight: 600, border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", textAlign: "center", whiteSpace: "nowrap" }}>
                                    대타근무급여
                                </th>
                                <th style={{ padding: "10px 16px", fontSize: "15px", fontWeight: 600, border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", textAlign: "center", whiteSpace: "nowrap" }}>
                                    추가반영
                                </th>
                                <th style={{ padding: "10px 16px", fontSize: "15px", fontWeight: 600, border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", textAlign: "center", whiteSpace: "nowrap" }}>
                                    인센티브
                                </th>
                                <th style={{ padding: "10px 16px", fontSize: "15px", fontWeight: 600, border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", textAlign: "center", whiteSpace: "nowrap" }}>
                                    모의고사 인센티브
                                </th>
                                <th style={{ padding: "10px 16px", fontSize: "15px", fontWeight: 600, border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", textAlign: "center", whiteSpace: "nowrap" }}>
                                    출장비
                                </th>
                                <th style={{ padding: "10px 16px", fontSize: "15px", fontWeight: 600, border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", textAlign: "center", whiteSpace: "nowrap" }}>
                                    메모
                                </th>
                                <th style={{ padding: "10px 16px", fontSize: "15px", fontWeight: 600, border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", textAlign: "center", whiteSpace: "nowrap" }}>
                                    세금(3.3)
                                </th>
                                <th style={{ padding: "10px 16px", fontSize: "15px", fontWeight: 600, border: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", textAlign: "center", whiteSpace: "nowrap" }}>
                                    세후금액
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {otherLocationList.map((loc) => {
                                const wage = otherLocationWages[loc.english] ?? 0;
                                const extra = otherLocationExtras[loc.english]?.extraAmount ?? 0;
                                const incentive = otherLocationIncentiveTotals[loc.english] ?? 0;
                                const mockExamIncentive = otherLocationMockExamIncentives[loc.english] ?? 0;
                                const travelAllowanceAmount = otherLocationTravelAllowances[loc.english] ?? 0;
                                const memo = otherLocationExtras[loc.english]?.memo ?? "";
                                const total = wage + extra + incentive + mockExamIncentive + travelAllowanceAmount;
                                const taxAmt = total > 0 ? Math.floor(total * 0.033) : 0;
                                const afterTaxAmt = total > 0 ? total - taxAmt : 0;

                                return (
                                    <tr key={loc.english}>
                                        <td style={{ padding: "8px 16px", fontSize: "15px", border: "1px solid #e0e0e0", textAlign: "center", whiteSpace: "nowrap" }}>
                                            {loc.korean}
                                        </td>
                                        <td style={{ padding: "8px 16px", fontSize: "15px", border: "1px solid #e0e0e0", textAlign: "right", whiteSpace: "nowrap" }}>
                                            {wage > 0 ? wage.toLocaleString() : ""}
                                        </td>
                                        <td style={{ padding: "8px 16px", fontSize: "15px", border: "1px solid #e0e0e0", textAlign: "right", whiteSpace: "nowrap" }}>
                                            <span>{extra > 0 ? `${extra.toLocaleString()}원` : ""}</span>
                                            <span
                                                style={{ cursor: "pointer", marginLeft: "6px" }}
                                                onClick={() => {
                                                    setExtraMemoEditLocation(loc.english);
                                                    setExtraMemoEditType("extra");
                                                    setExtraMemoInputValue(extra > 0 ? String(extra) : "");
                                                    setExtraMemoModalOpen(true);
                                                }}
                                            >
                                                <Create fontSize="small" color="disabled" />
                                            </span>
                                        </td>
                                        <td style={{ padding: "8px 16px", fontSize: "15px", border: "1px solid #e0e0e0", textAlign: "right", whiteSpace: "nowrap" }}>
                                            {incentive > 0 ? `${incentive.toLocaleString()}원` : ""}
                                        </td>
                                        <td style={{ padding: "8px 16px", fontSize: "15px", border: "1px solid #e0e0e0", textAlign: "right", whiteSpace: "nowrap" }}>
                                            {mockExamIncentive > 0 ? `${mockExamIncentive.toLocaleString()}원` : ""}
                                        </td>
                                        <td style={{ padding: "8px 16px", fontSize: "15px", border: "1px solid #e0e0e0", textAlign: "right", whiteSpace: "nowrap" }}>
                                            {travelAllowanceAmount > 0 ? `${travelAllowanceAmount.toLocaleString()}원` : ""}
                                        </td>
                                        <td style={{ padding: "8px 16px", fontSize: "15px", border: "1px solid #e0e0e0" }}>
                                            <span style={{ marginRight: "6px" }}>{memo}</span>
                                            <span
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    setExtraMemoEditLocation(loc.english);
                                                    setExtraMemoEditType("memo");
                                                    setExtraMemoInputValue(memo);
                                                    setExtraMemoModalOpen(true);
                                                }}
                                            >
                                                <Create fontSize="small" color="disabled" />
                                            </span>
                                        </td>
                                        <td style={{ padding: "8px 16px", fontSize: "15px", border: "1px solid #e0e0e0", textAlign: "right", whiteSpace: "nowrap" }}>
                                            {taxAmt > 0 ? taxAmt.toLocaleString() : ""}
                                        </td>
                                        <td style={{ padding: "8px 16px", fontSize: "15px", border: "1px solid #e0e0e0", textAlign: "right", whiteSpace: "nowrap", backgroundColor: "#e8f4fd" }}>
                                            {afterTaxAmt > 0 ? afterTaxAmt.toLocaleString() : ""}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={9} style={{ padding: "10px 16px", textAlign: "right", fontSize: "14px", color: "#3d50b0", fontWeight: 500, border: "1px solid #e0e0e0" }}>
                                    대타근무 + 추가반영 + 인센티브 + 모의고사 인센티브 + 출장비 합산금액의 3.3%
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            </div>
            )}

            <div style={{ height: "30px" }} />

            <AddWorkModal2
                open={modalOpen}
                onClose={() => {
                    setModalOpen(false);
                    setSelectedDate(null);
                }}
                selectedDate={selectedDate}
                user={props.user}
                data={data}
                notify={props.notify}
                setUpdate={setUpdate}
                locationFilter={modalCalendarType}
            />

            <RegisterWorkManually
                open={modalOpen6}
                onClose={() => {
                    setModalOpen6(false);
                }}
                selectedDate={selectedDate}
                user={props.user}
                notify={props.notify}
                setUpdate={setUpdate}
            />

            <WeekPayModal
                open={modalOpen2}
                user={props.user}
                onClose={() => {
                    setModalOpen2(false);
                }}
                selectedWeekPayDays={selectedWeekPayDays}
                setSelectedWeekPayDays={setSelectedWeekPayDays}
                notify={props.notify}
            />

            <IncentiveModal
                open={modalOpen3}
                user={props.user}
                onClose={() => {
                    setModalOpen3(false);
                }}
                notify={props.notify}
                selectedDate={date}
                incentiveData={incentiveData}
                setIncentiveUpdate={setIncentiveUpdate}
            />

            <MemoModal
                open={modalOpen4}
                user={props.user}
                date={date}
                onClose={() => {
                    setModalOpen4(false);
                }}
            />

            <DefaultWorkSettingModal
                open={modalOpen5}
                onClose={() => {
                    setModalOpen5(false);
                }}
                user={props.user}
                notify={props.notify}
                data={data}
                setUpdate={setUpdate}
            />

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open5}
                onClose={handleClose5}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {
                    (!isDefault && !isManually)
                        ?
                        <MenuItem onClick={() => {
                            if (selectedWorkId) {
                                requestHeadOffice(selectedWorkId);
                            }
                        }}>
                            본사 요청 대타 인증 요청
                        </MenuItem>
                        :
                        ""
                }
                <MenuItem onClick={handleDelete}>삭제하기</MenuItem>
            </Menu>

            <Menu
                id="basic-menu-2"
                anchorEl={anchorEl2}
                open={open6}
                onClose={handleClose6}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={() => {
                    registerWorkManually();
                }}>
                    근무 수동 등록하기
                </MenuItem>
                {
                    (props.forManager)
                        ?
                        <MenuItem onClick={() => {
                            setAnchorEl2(null);
                            setModalOpen7(true);
                        }}>
                            출입기록 수동 추가
                        </MenuItem>
                        :
                        ""
                }
            </Menu>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={centerLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <AddAccessModal
                open={modalOpen7}
                handleClose={() => setModalOpen7(false)}
                user={props.user}
                notify={props.notify}
                selectedDate={selectedDate}
                setUpdate={setUpdate}
                setAccessUpdate={setAccessUpdate}
            />

            <EmploymentInsuranceModal
                open={modalOpen8}
                onClose={() => setModalOpen8(false)}
                user={props.user}
                notify={props.notify}
                employmentInsurance={employmentInsurance}
                setEmploymentInsurance={setEmploymentInsurance}
            />

            <HolidayPayModal
                open={modalOpen9}
                onClose={() => setModalOpen9(false)}
                user={props.user}
                notify={props.notify}
                holidayPayApplied={holidayPayApplied}
                setHolidayPayApplied={setHolidayPayApplied}
            />

            <OtherLocationIncentiveModal
                open={otherIncentiveModalOpen}
                onClose={() => setOtherIncentiveModalOpen(false)}
                user={props.user}
                selectedDate={date}
                incentiveData={otherLocationIncentiveData}
                notify={props.notify}
                setIncentiveUpdate={setOtherIncentiveUpdate}
            />

            <Modal
                open={extraMemoModalOpen}
                onClose={() => {
                    setExtraMemoModalOpen(false);
                    setExtraMemoInputValue("");
                }}
            >
                <Box sx={incomeTaxModalStyle}>
                    <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "12px" }}>
                        {extraMemoEditType === "extra" ? "추가반영 수정" : "메모 수정"}
                        {extraMemoEditLocation ? ` — ${englishLocationToKorean(extraMemoEditLocation)}` : ""}
                    </div>
                    <Input
                        value={extraMemoInputValue}
                        onChange={(e: any) => {
                            const val = e.target.value;
                            if (extraMemoEditType === "extra") {
                                setExtraMemoInputValue(val.replace(/[^0-9]/g, ""));
                            } else {
                                setExtraMemoInputValue(val);
                            }
                        }}
                        placeholder={extraMemoEditType === "extra" ? "금액을 입력하세요" : "메모를 입력하세요"}
                    />
                    <div style={{ marginTop: "28px" }}>
                        <Button
                            variant="solid"
                            fullWidth
                            onClick={saveOtherLocationExtra}
                            loading={extraMemoSaveLoading}
                        >
                            저장
                        </Button>
                    </div>
                </Box>
            </Modal>

        </div>
    );
};

export default ShopSalaryRegister2;
